const messages = {
    pageTitle: 'Lista notek dla stanowisk produkcyjnych',
    menuTitle: 'Notki stanowiskowe',
    createNotePageTitle: 'Dodaj notkę',
    editNotePageTitle: 'Edytuj notkę',
    actions: {
        add: 'Dodaj notkę',
        open: 'Otwórz',
        delete: 'Usuń',
        save: 'Zapisz',
        accept: 'Zatwierdź',
        send: 'Wyślij',
        sendComment: 'Wyślij komentarz',
        backToList: 'Powrót do listy',
        markAsRead: 'Oznacz jako przeczytane',
        acknowledge: 'Zapoznałem się',
        sentryLabels: {
            add: 'Dodaj notkę stanowiskową',
            open: 'Otwórz notkę stanowiskową',
            delete: 'Usuń notkę stanowiskową',
            save: 'Zapisz notkę stanowiskową',
            accept: 'Zatwierdź notkę stanowiskową',
            sendComment: 'Wyślij komentarz do notki stanowiskowej'
        }
    },
    filters: {
        unreadOnly: 'Tylko nieprzeczytane'
    },
    table: {
        headers: {
            title: 'Tytuł',
            author: 'Autor',
            createdAt: 'Data utworzenia',
            expireDateTime: 'Data wygaśnięcia',
            originProductionSite: 'Stanowisko',
            approved: 'Czy udostępniona',
            adminAccepted: 'Czy zatwierdzona',
            actions: 'Akcje'
        },
        readByHeaders: {
            employee: 'Pracownik',
            readDateTime: 'Data odczytu',
            confirmDateTime: 'Data potwierdzenia'
        },
        commentsHeaders: {
            employee: 'Pracownik',
            createdAt: 'Data utworzenia',
            comment: 'Treść'
        }
    },
    form: {
        sections: {
            noteData: 'Dane notki',
            readBy: 'Zapoznali się',
            comments: 'Komentarze',
            fileLinks: 'Linki do pliku'
        },
        fields: {
            title: 'Tytuł',
            description: 'Opis',
            fileLink: 'Link do pliku',
            fileLinkDescription: 'Opis',
            visibility: 'Widoczność',
            byAdmin: 'przez administratora',
            author: 'Autor',
            expireDateTime: 'Planowana data wygaśnięcia',
            createdAt: 'Data utworzenia',
            selectAll: 'Zaznacz wszystkie',
            productionSites: 'Widoczność na stanowiskach:',
            productionSitesPlaceholder: 'Wybierz stanowiska',
            originProductionSite: 'Stanowisko utworzenia',
            addComment: 'Dodaj komentarz'
        },
        labels: {
            public: 'publiczna',
            private: 'niepubliczna',
            accepted: 'zatwierdzona',
            notAccepted: 'nie zatwierdzona'
        },
        actions: {
            clear: 'Wyczyść',
            save: 'Zapisz',
            addFileLink: 'Dodaj'
        }
    },
    validation: {
        titleRequired: 'Proszę podać tytuł notki.',
        textRequired: 'Proszę podać opis notki.',
        productionSitesRequired: 'Proszę wybrać co najmniej jedno stanowisko.',
        expireDateTimeRequired: 'Proszę podać datę wygaśnięcia.',
        fileLinkUrlRequired: 'Proszę podać link do pliku.',
        fileLinkUrlInvalid: 'Podany adres URL jest nieprawidłowy.'
    },
    dialogs: {
        deleteNote: {
            title: 'Usunięcie notki',
            message: 'Czy na pewno chcesz usunąć notkę?',
            confirmButton: 'Potwierdź'
        }
    },
    notifications: {
        fetchNotesError: 'Pobranie notek stanowiskowych nie powiodło się.',
        fetchNoteError: 'Pobranie danych notki stanowiskowej nie powiodło się.',
        noteCreated: 'Notka stanowiskowa została dodana.',
        noteCreationError: 'Dodanie notki stanowiskowej nie powiodło się.',
        noteUpdated: 'Edytowano notkę stanowiskową.',
        noteUpdateError: 'Edycja notki stanowiskowej nie powiodła się.',
        noteDeleted: 'Notka stanowiskowa została usunięta.',
        noteDeleteError: 'Usunięcie notki stanowiskowej nie powiodło się.',
        commentCreated: 'Dodano komentarz.',
        commentCreationError: 'Dodanie komentarza nie powiodło się.',
        fetchUnreadNotesError: 'Pobranie nieodczytanych notek nie powiodło się.',
        fetchUnreadNotesAmountError: 'Pobranie ilości nieodczytanych notek nie powiodło się.',
        noteConfirmed: 'Notatka została potwierdzona.',
        noteConfirmError: 'Potwierdzenie notatki nie powiodło się.'
    }
}

export default {
    messages,
    locale: 'pl'
}
